module.exports = __webpack_public_path__ + "static/media/mode-551.07c7e63d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-551.svg
// module id = 1058
// module chunks = 2